import { Navigate, useLocation } from "react-router-dom";

import { useAuth } from "../../context/AuthContext";

export default function RouteAuth({ superUser, children }: { superUser?: boolean; children: JSX.Element }) {
	const { user } = useAuth();
	const location = useLocation();

	if (!user || (superUser && !user.superUser)) {
		return <Navigate to="/" state={{ from: location }} replace />;
	}

	return children;
}
